/**
 * A length of time as a person would say it: "45s", "10 min", "2 h",
 * "1 d 4 h". Turn mode's clock runs to days and normal mode's to
 * seconds, so one unit cannot serve both.
 */
export function formatDuration(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const leftSeconds = seconds % 60;
  if (minutes < 60) return leftSeconds ? `${minutes} min ${leftSeconds}s` : `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const leftMinutes = minutes % 60;
  if (hours < 24) return leftMinutes ? `${hours} h ${leftMinutes} min` : `${hours} h`;
  const days = Math.floor(hours / 24);
  const leftHours = hours % 24;
  return leftHours ? `${days} d ${leftHours} h` : `${days} d`;
}

/** A countdown's reading: m:ss, h:mm:ss past an hour, and days in front
 * past a day. */
export function formatClock(seconds: number): string {
  const s = String(seconds % 60).padStart(2, '0');
  const totalMinutes = Math.floor(seconds / 60);
  if (totalMinutes < 60) return `${totalMinutes}:${s}`;
  const m = String(totalMinutes % 60).padStart(2, '0');
  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) return `${totalHours}:${m}:${s}`;
  return `${Math.floor(totalHours / 24)}d ${totalHours % 24}:${m}:${s}`;
}
